export const showError = (error) => {
  if (error) {
    console.log(error);
  }
};
